import React from 'react'
import { UserComponent } from '../TopRow/UserComponent/UserComponent'
import { LoginLinkComponent } from '../TopRow/LoginLink/LoginLinkComponent'
import { AuthViewProps } from './AppTop.interface'

export const AuthSection: React.FC<AuthViewProps> = ({ user, isLoggedIn }) => (
  <div>
    {isLoggedIn && <UserComponent user={user} />}
    {!isLoggedIn && <LoginLinkComponent />}
  </div>
)
